module.exports = __webpack_public_path__ + "img/firmware-icon.ba857efd.svg";